export default "__VITE_ASSET__Bo9ML3nO__"